import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";

export const FlashcardsIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill={color}
      stroke={color}
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M180,72H36A20,20,0,0,0,16,92V204a20,20,0,0,0,20,20H180a20,20,0,0,0,20-20V92A20,20,0,0,0,180,72Zm-4,128H40V96H176ZM240,52V176a12,12,0,0,1-24,0V56H64a12,12,0,0,1,0-24H220A20,20,0,0,1,240,52Z" />
    </svg>
  )
);

FlashcardsIcon.displayName = "FlashcardsIcon";
